import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ModalContentLayout from "./modal-content-layout.component";

import { useTranslation } from "utils/hooks/use-translation.hook";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";

interface ConfirmationCreationType {
    details: any;
    closeModal: () => void;
    callback: (edited: boolean) => void;
}

const ConfirmationUpdateLayerModal = ({
    closeModal,
    callback,
}: ConfirmationCreationType) => {
    const translate = useTranslation();

    return (
        <ModalContentLayout
            firstButtonStatus="enabled"
            secondButtonStatus="enabled"
            onFirstButtonClick={closeModal}
            onSecondButtonClick={() => callback(true)}
            firstButtonTitle={translate("app.gis.cancel")}
            secondButtonTitle={translate("app.hierarchy.modify")}
        >
            <div className="c-confirmation-modal">
                <FontAwesomeIcon
                    className="c-confirmation-modal__icon"
                    icon={faExclamationTriangle}
                />
                <span className="c-confirmation-modal__body">
                    {translate("app.gis.update_confirmation")}
                </span>
            </div>
        </ModalContentLayout>
    );
};

export default ConfirmationUpdateLayerModal;
